import React, { useEffect, useState, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../../context/AuthContext";
import "./ProWelcome.css";

const UNLOCKED = [
  {
    title: "All premium tracks",
    desc: "Frontend, Backend, VLSI, Embedded — every phase is now fully open.",
  },
  {
    title: "Unlimited AI assessments",
    desc: "Test understanding at every phase. Retake as many times as you need.",
  },
  {
    title: "Verified certificates live",
    desc: "Recruiters can verify your completed tracks directly on your public profile.",
  },
  {
    title: "Advanced analytics unlocked",
    desc: "Readiness score, global ranking, and phase insights are now visible.",
  },
];

export default function ProWelcome() {
  const { checkAuth } = useContext(AuthContext);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    checkAuth().finally(() => {
      setTimeout(() => setLoading(false), 800);
    });
  }, [checkAuth]);

  return (
    <div className="pw-page">
      <div className="pw-card">
        {loading ? (
          <div className="pw-syncing">
            <div className="pw-spinner" />
            <p>Activating your premium features…</p>
          </div>
        ) : (
          <>
            <div className="pw-icon-wrap">
              <div className="pw-ring pw-ring--outer" />
              <div className="pw-ring pw-ring--inner" />
              <div className="pw-icon-circle">★</div>
            </div>

            <div className="pw-pro-pill">
              <div className="pw-pro-dot" />
              PRO activated
            </div>

            <h1 className="pw-title">Welcome to Learnlia PRO</h1>
            <p className="pw-sub">
              Your payment went through. Every premium feature is live on your account right now.
            </p>

            <div className="pw-features">
              {UNLOCKED.map((f, i) => (
                <div key={i} className="pw-feat">
                  <div className="pw-feat-check">✓</div>
                  <div>
                    <strong>{f.title}</strong>
                    <p>{f.desc}</p>
                  </div>
                </div>
              ))}
            </div>

            <button className="pw-cta" onClick={() => navigate("/tracks")}>
              Continue learning →
            </button>
            <p className="pw-note">
              Manage your subscription anytime from your profile.
            </p>
          </>
        )}
      </div>
    </div>
  );
}